import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import NavBar from '../Layout/NavBar';
import SideBar from '../Layout/SideBar';
import Content from '../Layout/Content';
import Tile from '../Layout/Tile';

class SkeletonContainer extends Component {
    render(){
        const { title, children, history: { goBack } } = this.props;
        return (
            <div>
                <NavBar />
                <Container className="px-0" fluid>
                    <Row className="m-0">
                        <SideBar />
                        <Content>
                            <div style={{marginTop:"75px",marginLeft:"5px",backgroundColor: "#f2f2f2"}}>
                                <h5>
                                    { typeof title === "function" ? title() : title }
                                    <span className="ml-1 btn btn-primary" onClick={() => goBack()}>Back</span>
                                </h5>
                            </div>
                            <Tile xs="12" style={{marginTop:0,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                { children }
                            </Tile>
                        </Content>
                    </Row>

                </Container>
            </div>            
        );
    }
}

export default withRouter(SkeletonContainer);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/SkeletonContainer.js